module.exports = __webpack_public_path__ + "img/16.a5b65e1d.jpg";